import { render, staticRenderFns } from "./AlertsNotificationsPanel.vue?vue&type=template&id=0161d094&scoped=true&"
import script from "./AlertsNotificationsPanel.vue?vue&type=script&lang=js&"
export * from "./AlertsNotificationsPanel.vue?vue&type=script&lang=js&"
import style0 from "./AlertsNotificationsPanel.vue?vue&type=style&index=0&id=0161d094&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0161d094",
  null
  
)

export default component.exports